// extracted by mini-css-extract-plugin
module.exports = {"column":"BrowserRow_column__1eSV1","container":"BrowserRow_container__Is8TT","active":"BrowserRow_active__3T8su","cell":"BrowserRow_cell__2Enav"};